import React, { useEffect, useState } from "react";
import MuiHeader from "../../components/MuiHeader";
// MUI
import {
  TextField,
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
  Pagination,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MuiLoader from "../../components/MuiLoader";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import MuiSearch from "../../components/MuiSearch";
import { grey } from "@mui/material/colors";
import {
  getAllBlocks,
  getAllDistricts,
  gettotalusersbyusertypeThunk,
  newUserSwapThunk,
  userSwapThunk,
} from "./UserSwapThunk";
import defaultImage from "./../../assets/images/default-user-profile-image.jpg";

const SwapModal = ({
  isModalOpen,
  onClose,
  selectedUser,
  updateData,
  handleNewUserUpdate,
  onPhoneChange,
  onUserNameChange,
  onUserIdChange,
  onGenderChange,
  onStateChange,
  districts,
  onDistrictId,
  blocks,
  onBlockId,
  filterData,
  existingUserSelect,
}) => {
  const [swapType, setSwapType] = useState("");
  const [newUserId, setNewUserId] = useState("");
  console.log("newUserId====>", newUserId);
  const [newUserName, setNewUserName] = useState("");
  const [newUserPhone, setNewUserPhone] = useState("");
  const [gender, setGender] = useState("");
  const [stateId, setStateId] = useState("OR");

  const [districtId, setDistrictId] = useState("");
  const [districtName, setDistrictName] = useState("");

  const [blockId, setBlockId] = useState("");
  const [blockName, setBlockName] = useState("");

  const [selectedUserToSwap, setSelectedUserToSwap] = useState(null);

  const handleDistricts = (e) => {
    setDistrictId(e.target.value);
    onDistrictId(e.target.value);
  };

  const handleBlockChange = (e) => {
    setBlockId(e.target.value);
    onBlockId(e.target.value);
  };

  const handleNewUserId = (e) => {
    onUserIdChange(e.target.value);
    setNewUserId(e.target.value);
  };

  const handleNewUserName = (e) => {
    onUserNameChange(e.target.value);
    setNewUserName(e.target.value);
  };

  const handlePhone = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/[^0-9]/g, "");
    if (numericValue.length <= 10) {
      setNewUserPhone(numericValue);
      onPhoneChange(numericValue);
    }
  };

  const handleGender = (e) => {
    onGenderChange(e.target.value);
    setGender(e.target.value);
  };

  const handleStateId = (e) => {
    onStateChange(e.target.value);
    setStateId(e.target.value);
  };

  const onCloseModal = () => {
    onClose();
    setSwapType("");
    setSelectedUserToSwap(null);
    setNewUserId("");
    setNewUserName("");
    setNewUserPhone("");
    setBlockId("");
    // setStateId("");
    setDistrictId("");
    setGender("");
  };

  const handleNewUserUpdateModal = () => {
    // setSwapType("");
    // setSelectedUserToSwap(null);
    // setNewUserId("");
    // setNewUserName("");
    // setNewUserPhone("");
    // setBlockId("");
    // setStateId("");
    // setDistrictId("");
    // setGender("");
    handleNewUserUpdate();
  };

  const handleSelectedUserSwap = (newValue) => {
    setSelectedUserToSwap(newValue);
    existingUserSelect(newValue);
  };

  const handleSwapChange = (e) => {
    setSwapType(e.target.value);
    setNewUserId("");
    setNewUserName("");
    setNewUserPhone("");
    setBlockId("");
    // setStateId("");
    setDistrictId("");
    setGender("");
  };

  const updateDataModal = () => {
    setSwapType("");
    updateData();
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={onClose}
      // sx={{ width: "80%", maxWidth: "lg" }}
    >
      <DialogTitle>{`User ID: ${selectedUser.userid}`}</DialogTitle>
      {/* <DialogContent> */}
      {/* <div>{`User ID: ${selectedUser.userid}`}</div> */}
      {/* </DialogContent> */}

      <FormControl style={style}>
        <InputLabel>Swap Type</InputLabel>
        <Select value={swapType} onChange={(e) => handleSwapChange(e)}>
          <MenuItem value="option1">With existing user</MenuItem>
          <MenuItem value="option2">With new user</MenuItem>
        </Select>
      </FormControl>

      {swapType === "option1" && (
        <>
          <DialogContent>
            <FormControl fullWidth>
              <Autocomplete
                options={filterData}
                getOptionLabel={(option) => option.username}
                value={selectedUserToSwap}
                onChange={(event, newValue) => handleSelectedUserSwap(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Select a user to swap with" />
                )}
              />
            </FormControl>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => onCloseModal()}>Close</Button>
            <Button onClick={() => updateDataModal()}>Update Data</Button>
          </DialogActions>
        </>
      )}

      {swapType === "option2" && (
        <>
          <FormControl style={textField}>
            <TextField
              id="userid"
              label="User ID"
              name="userid"
              // type="email"
              value={newUserId}
              onChange={(e) => handleNewUserId(e)}
              autoComplete="userid"
              disabled={false}
              size="small"
              margin="normal"
              required
              fullWidth
              autoFocus
              InputProps={{
                style: textField.input,
              }}
            />
          </FormControl>
          <FormControl style={textField}>
            <TextField
              id="userid"
              label="User Name"
              name="userid"
              value={newUserName}
              onChange={(e) => handleNewUserName(e)}
              autoComplete="userid"
              disabled={false}
              size="small"
              margin="normal"
              required
              fullWidth
              autoFocus
              InputProps={{
                style: textField.input,
              }}
            />
          </FormControl>
          <FormControl style={textField}>
            <TextField
              id="Phone"
              label="Phone"
              name="Phone"
              type="number"
              value={newUserPhone}
              onChange={(e) => handlePhone(e)}
              autoComplete="Phone"
              disabled={false}
              size="small"
              margin="normal"
              required
              fullWidth
              autoFocus
              InputProps={{
                style: textField.input,
              }}
            />
          </FormControl>
          <FormControl style={style}>
            <InputLabel>Gender</InputLabel>
            <Select value={gender} onChange={(e) => handleGender(e)}>
              <MenuItem value="male">Male</MenuItem>
              <MenuItem value="female">Female</MenuItem>
            </Select>
          </FormControl>
          <FormControl style={style}>
            <InputLabel>State</InputLabel>
            <Select value={stateId} onChange={(e) => handleStateId(e)}>
              <MenuItem value="OR">Odisha</MenuItem>
            </Select>
          </FormControl>{" "}
          <FormControl style={style}>
            <InputLabel>Select District</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              label="Select District"
              value={districtId}
              onChange={(e) => handleDistricts(e)}
            >
              <MenuItem value="">None</MenuItem>
              {districts.map((option) => (
                <MenuItem value={option._id}>{option.districtname}</MenuItem>
              ))}
            </Select>
          </FormControl>{" "}
          <FormControl style={style}>
            <InputLabel>Select Blocks</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              label="Select District"
              value={blockId}
              onChange={handleBlockChange}
            >
              <MenuItem value="">None</MenuItem>
              {blocks.map((option) => (
                <MenuItem value={option._id}>{option.blockname}</MenuItem>
              ))}
            </Select>
          </FormControl>{" "}
          <DialogActions>
            <Button onClick={() => onCloseModal()}>Close</Button>
            <Button onClick={() => handleNewUserUpdateModal()}>
              Update Data
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

const UserSwap = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();

  function UserImage({ src }) {
    return (
      <img
        src={src}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = defaultImage;
        }}
        alt=""
      />
    );
  }

  const [usertype, setUsertype] = useState("");
  const [searchText, setSearchText] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [gender, setGender] = useState("");
  const [stateId, setStateId] = useState("OR");
  const [loading, setLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  // console.log("districts--->", districts);
  const [districtId, setDistrictId] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blocks, setBlocks] = useState([]);
  const [blockId, setBlockId] = useState("");
  const [blockName, setBlockName] = useState("");
  // console.log("blockName--->", blockName);
  const [selectedUserToSwap, setSelectedUserToSwap] = useState(null);
  // console.log("selectedUserToSwap--->", selectedUserToSwap);
  const [newUserId, setNewUserId] = useState("");
  // console.log("newUserId====>", newUserId);
  const [newUserName, setNewUserName] = useState("");
  console.log("newUserName======>", newUserName);
  const [newUserPhone, setNewUserPhone] = useState("");
  const [selectedUserid, setSelectedUserid] = useState("");
  const [selectedUsername, setSelectedUsername] = useState("");
  const itemsPerPage = 10;

  useEffect(() => {
    getAllDistricts().then((item) => {
      // console.log("districts---->", item.data);
      setDistricts(item.data);
    });
  }, []);

  const usertype_select_onchange = (e) => {
    // console.log("check--->", e.target.value);
    setUsertype(e.target.value);
    setLoading(true);
    const body = {
      usertype: e.target.value,
    };
    gettotalusersbyusertypeThunk(body).then((item) => {
      // console.log("techaer---->", item.data, item);

      if (item.status === 200) {
        setLoading(false);
        setFilterData(item.data);
      }
    });
  };
  const searchTextOnChange = (event) => {
    setSearchText(event.target.value);
    // console.log("thi====>", event.target.value.length);
    if (event.target.value.length > 0) {
      const searchResults = filterData.filter((item) =>
        item.username.toLowerCase().includes(event.target.value.toLowerCase())
      );
      setFilterData(searchResults);
    } else {
      const body = {
        usertype: usertype,
      };
      gettotalusersbyusertypeThunk(body).then((item) => {
        // console.log("techaer---->", item.data, item);

        if (item.status === 200) {
          setLoading(false);
          setFilterData(item.data);
        }
      });
    }
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filterData.slice(indexOfFirstItem, indexOfLastItem);

  const handleSwapClick = (user) => {
    // console.log("selecteduser------>", user);
    setSelectedUser(user);
    setModalOpen(true);
  };

  const onUserIdChange = (value) => {
    setNewUserId(value);
  };

  const onUserNameChange = (value) => {
    setNewUserName(value);
  };

  const onPhoneChange = (value) => {
    setNewUserPhone(value);
  };

  const onGenderChange = (value) => {
    setGender(value);
  };
  const onStateChange = (value) => {
    setStateId(value);
  };

  const onDistrictId = (value) => {
    setDistrictId(value);
    const selectedDistrict = districts.filter((item) => item._id === value);
    // console.log("selectedDistrict--->", selectedDistrict);
    setDistrictName(selectedDistrict ? selectedDistrict[0].districtname : "");
    const data = {
      districtId: value,
    };
    getAllBlocks(data).then((item) => {
      // console.log("blocks---->", item.data);
      setBlocks(item.data);
    });
  };

  const onBlockId = (value) => {
    setBlockId(value);
    const selectedBlock = blocks.filter((item) => item._id === value);
    // console.log("selectedBlock--->", selectedBlock);
    setBlockName(selectedBlock ? selectedBlock[0].blockname : "");
  };

  const updateData = () => {
    const data = {
      olduserid: selectedUser?.userid,
      newuserid: selectedUserid,
      newusername: selectedUsername,
    };
    console.log("updateData=======>", data);
    userSwapThunk(data).then((item) => {
      // console.log("response check---->", item.data, item.status);
      if (item.status === 200) {
        toast.success("Swapped successfully");
        setModalOpen(false);
      } else {
        setModalOpen(false);
        toast.error("Swapped Failed");
      }
    });
  };

  const existingUserSelect = (newValue) => {
    console.log("newValue---->", newValue);
    setSelectedUserid(newValue.userid);
    setSelectedUsername(newValue.username);
  };

  const handleNewUserUpdate = () => {
    if (
      blockId &&
      blockName &&
      districtId &&
      districtName &&
      newUserId &&
      gender &&
      selectedUser?.userid &&
      newUserName &&
      newUserPhone
    ) {
      const data = {
        blockid: blockId,
        blockname: blockName,
        districtid: districtId,
        districtname: districtName,
        emailid: newUserId,
        gender: gender,
        olduserid: selectedUser?.userid,
        newuserid: newUserId,
        newusername: newUserName,
        phone: newUserPhone,
        schoolname: "thinkzone school",
        stateid: stateId,
        statename: "odisha",
        udisecode: "21060711601",
        usertype: "fellow",
      };

      // console.log("data--->", data);

      newUserSwapThunk(data)
        .then((item) => {
          // console.log("response check---->", item.data, item.status);
          if (item.status === 200) {
            toast.success("Swapped successfully");
            setModalOpen(false);
          } else {
            toast.error("Swapped Failed");
          }
        })
        .catch((error) => {
          toast.error("An error occurred while swapping.");
        });
    } else {
      toast.error("Required fields are missing! Swapped Failed");
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      <MuiHeader
        header="User Swap"
        NavbarStatus={true}
        usertype_select_option_list={data}
        usertype_select_onchange={usertype_select_onchange}
        usertype={usertype}
      />

      <Grid item xs={3}>
        {currentItems?.length > 0 ? (
          <Box p={2}>
            <MuiSearch
              searchText={searchText}
              searchTextOnChange={searchTextOnChange}
            />
          </Box>
        ) : null}

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            {currentItems.map((user, index) => (
              <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
                <Card sx={{ maxWidth: 345, height: 150 }}>
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: grey[500] }}>
                        {user.image ? (
                          <>
                            <UserImage src={user.image} />
                          </>
                        ) : (
                          user.username.substring(0, 2).toUpperCase()
                        )}
                      </Avatar>
                    }
                    title={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ cursor: "pointer" }}>
                          {user.username ? user.username : null}
                        </div>
                        <IconButton
                          sx={{
                            backgroundColor: "blue",
                            color: "white",
                            "&:hover": {
                              backgroundColor: "darkblue",
                            },
                          }}
                          onClick={() => handleSwapClick(user)}
                        >
                          <SwapHorizIcon />
                        </IconButton>
                      </div>
                    }
                    subheader={
                      <div style={{ cursor: "pointer" }}>
                        <div>{user.userid ? user.userid : ""}</div>
                        <div>
                          {user.usertype ? user.usertype : ""},{" "}
                          {user.status ? user.status : ""}
                        </div>
                        <div>
                          {user.permanentaddress ? user.permanentaddress : ""}
                        </div>
                      </div>
                    }
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {currentItems?.length > 0 ? (
          <Box mt={2} display="flex" justifyContent="center">
            <Pagination
              count={Math.ceil(filterData.length / itemsPerPage)}
              page={currentPage}
              onChange={handlePageChange}
            />
          </Box>
        ) : null}

        <MuiLoader open={loading} />
      </Grid>
      <ToastContainer />
      <SwapModal
        filterData={filterData}
        isModalOpen={isModalOpen}
        onClose={() => handleModalClose()}
        selectedUser={selectedUser}
        updateData={updateData}
        onUserIdChange={onUserIdChange}
        onGenderChange={onGenderChange}
        onPhoneChange={onPhoneChange}
        onStateChange={onStateChange}
        onUserNameChange={onUserNameChange}
        handleNewUserUpdate={handleNewUserUpdate}
        districts={districts}
        onDistrictId={onDistrictId}
        blocks={blocks}
        onBlockId={onBlockId}
        existingUserSelect={existingUserSelect}
      />
    </>
  );
};

export default UserSwap;

const style = {
  marginTop: 12,
  marginLeft: 12,
  marginRight: 12,
  margin: 10,
  padding: 10,
};
const styles = {
  marginTop: 12,
  marginLeft: 12,
  marginRight: 12,
  margin: 10,
  padding: 10,
  height: 150,
};

const textField = {
  width: "90%",
  marginLeft: "auto",
  marginRight: "auto",
  paddingBottom: 0,
  marginTop: 0,

  input: {
    color: "black",
    height: 50,
  },
};

const data = [
  { value: "fellow", text: "Fellow" },
  { value: "school", text: "School" },
  { value: "anganwadi", text: "Anganwadi" },
];
